var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F5F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.61719C12.4962 7.61719 12.8984 8.01943 12.8984 8.51562C12.8984 9.01182 12.4962 9.41406 12 9.41406C11.5038 9.41406 11.1016 9.01182 11.1016 8.51562C11.1016 8.01943 11.5038 7.61719 12 7.61719Z",
    fill: "#1A1A1A",
    stroke: "#181818",
    strokeWidth: 0.078125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6016C12.4962 11.6016 12.8984 12.0038 12.8984 12.5C12.8984 12.9962 12.4962 13.3984 12 13.3984C11.5038 13.3984 11.1016 12.9962 11.1016 12.5C11.1016 12.0038 11.5038 11.6016 12 11.6016Z",
    fill: "#1A1A1A",
    stroke: "#181818",
    strokeWidth: 0.078125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5859C12.4962 15.5859 12.8984 15.9882 12.8984 16.4844C12.8984 16.9806 12.4962 17.3828 12 17.3828C11.5038 17.3828 11.1016 16.9806 11.1016 16.4844C11.1016 15.9882 11.5038 15.5859 12 15.5859Z",
    fill: "#1A1A1A",
    stroke: "#181818",
    strokeWidth: 0.078125
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDot);
export default __webpack_public_path__ + "static/media/three-dot.0c1ff7a620b99428e50086a581036253.svg";
export { ForwardRef as ReactComponent };